/**
 * @file SiteClosedPublishNote.tsx
 * @description Строка в окне публикации при закрытом сайте (phase19.16,
 * SB138; uiux-site-closed.md §8; db-design-site-closed.md §6): публиковать
 * можно, но покупатели увидят изменения только после открытия сайта.
 * Состояние только читается (опрос ведёт каркас кабинета); нет данных —
 * строки нет.
 */

import { NoticeStrip } from "../ui/NoticeStrip";
import { useShopContextKey, useSiteAccess } from "../../hooks/site-access/useSiteAccess";
import { activeSiteClosure } from "../../lib/site-access/site-access-view";

/** Текст строки. */
export const SITE_CLOSED_PUBLISH_NOTE = "Сайт сейчас закрыт — изменения увидят покупатели, когда вы его откроете.";

export function SiteClosedPublishNote() {
  const access = useSiteAccess(useShopContextKey(), "read");
  if (!activeSiteClosure(access.state, access.serverNow())) return null;
  return (
    <NoticeStrip tone="warning" className="shrink-0">
      {SITE_CLOSED_PUBLISH_NOTE}
    </NoticeStrip>
  );
}
